import { primitives, themes } from 'styles/colors'

export type ColorName = keyof typeof primitives
export type ThemeName = keyof typeof themes
export type RoleName = keyof (typeof themes)['light']

// An own-property check, so a name like "constructor" doesn't read Object.prototype.
export const isThemeName = (name: string): name is ThemeName => Object.prototype.hasOwnProperty.call(themes, name)

// Primitive values for inline styles, style objects and SVG attributes. These can't
// use var(--…): PostCSS replaces primitive properties with their values at build
// time, so none exist in the page.
export const color = (name: ColorName): string => primitives[name]

// A role for inline styles and an SVG element's style, following the theme. SVG
// presentation attributes (fill=, stroke=) and canvas drawing don't resolve var();
// they take the role's value from hooks/useThemeColor.
export const cssVar = (role: RoleName): string => `var(--${role})`

export const CHART_SERIES: readonly string[] = [
  color('chart-1'),
  color('chart-2'),
  color('chart-3'),
  color('chart-4'),
  color('chart-5'),
  color('chart-6'),
  color('chart-7'),
  color('chart-8')
]

// The "everything else" bucket after a chart's named series.
export const CHART_OTHER = color('neutral-300')
